// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2tf9T","errors":"Errors_errors__1FIyM"};